import { Phone, MessageCircle, FileText } from "lucide-react";
import { useEffect, useState } from "react";
import { trackEvent } from "@/utils/tracking";
import { openWhatsApp } from "@/utils/phone";
import { trackLead } from "@/lib/tracking";
import { getServiceLandingBySlug } from "@/data/serviceLandingData";

const getGewerkSlug = () => {
  const p = window.location.pathname.replace(/^\//, "");
  return p || null;
};

const scrollToForm = () => {
  const el = document.getElementById("landing-form") || document.getElementById("lead-form");
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    window.location.href = "/#lead-form";
  }
};

const StickyButtons = ({ settings }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Mobil: Platz für die fixe Leiste schaffen (Footer-Links bleiben erreichbar)
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 639px)');
    const apply = () => { document.body.style.paddingBottom = mq.matches ? '64px' : ''; };
    apply();
    mq.addEventListener('change', apply);
    return () => {
      mq.removeEventListener('change', apply);
      document.body.style.paddingBottom = '';
    };
  }, []);

  const phoneNumber = settings?.phone || '4917620283482';

  const handleWhatsAppClick = (source) => {
    const whatsappNumber = settings?.whatsapp_number || '4917620283482';
    const landing = getServiceLandingBySlug(getGewerkSlug() || "");
    const message = landing
      ? `Hallo, ich interessiere mich für ${landing.formService}.`
      : "Hallo BEKAJ BAU,\nich interessiere mich für eine Bauleistung.\n\nIch möchte gerne mehr erfahren.";
    trackLead("whatsapp", getGewerkSlug());
    openWhatsApp(whatsappNumber, message);
    trackEvent('contact_whatsapp', { source });
  };

  const handlePhoneClick = (source) => {
    trackLead("anruf", getGewerkSlug());
    trackEvent('call_click', { source });
  };

  return (
    <>
      {/* Desktop: runde Buttons unten links (nach Scroll sichtbar) */}
      {isVisible && (
        <div className="hidden sm:flex fixed bottom-6 left-6 z-50 flex-col gap-3" data-testid="sticky-buttons">
          <a
            href={`tel:+${phoneNumber}`}
            onClick={() => handlePhoneClick('sticky_button')}
            className="w-14 h-14 sm:w-16 sm:h-16 bg-[#4A331D] hover:bg-[#593B23] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all animate-bounce"
            data-testid="sticky-phone-button"
            data-track="phone_click"
            data-track-value="sticky"
            aria-label="Anrufen"
          >
            <Phone className="w-6 h-6 sm:w-7 sm:h-7" />
          </a>

          <button
            onClick={() => handleWhatsAppClick('sticky_button')}
            className="w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all"
            data-testid="sticky-whatsapp-button"
            data-track="whatsapp_click"
            data-track-value="sticky"
            aria-label="WhatsApp"
          >
            <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7" />
          </button>
        </div>
      )}

      {/* Mobil: dauerhafte Vollbreite-Leiste am unteren Rand */}
      <div
        className="sm:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-3 border-t border-[#e8dfd4] bg-white shadow-[0_-2px_12px_rgba(0,0,0,0.12)]"
        data-testid="sticky-mobile-bar"
      >
        <a
          href={`tel:+${phoneNumber}`}
          onClick={() => handlePhoneClick('sticky_mobile_bar')}
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 bg-[#4A331D] text-white text-xs font-semibold active:bg-[#593B23]"
          data-testid="sticky-bar-call"
          data-track="phone_click"
          data-track-value="sticky_mobile"
          aria-label="Anrufen"
        >
          <Phone className="w-5 h-5" />
          Anrufen
        </a>
        <button
          onClick={() => handleWhatsAppClick('sticky_mobile_bar')}
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 bg-[#25D366] text-white text-xs font-semibold active:bg-[#20bd5a]"
          data-testid="sticky-bar-whatsapp"
          data-track="whatsapp_click"
          data-track-value="sticky_mobile"
          aria-label="WhatsApp"
        >
          <MessageCircle className="w-5 h-5" />
          WhatsApp
        </button>
        <button
          onClick={scrollToForm}
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 bg-[#D4AA6A] text-[#4A331D] text-xs font-bold active:bg-[#c49a5a]"
          data-testid="sticky-bar-offer"
          aria-label="Kostenloses Angebot"
        >
          <FileText className="w-5 h-5" />
          Angebot
        </button>
      </div>
    </>
  );
};

export default StickyButtons;
